import { render, staticRenderFns } from "./ProjectEditor.vue?vue&type=template&id=abc5d69c"
import script from "./ProjectEditor.vue?vue&type=script&lang=ts"
export * from "./ProjectEditor.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports